// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"16257274","564":"5c34c659","787":"9eaa9f11"}[chunkId] + ".chunk.js";
};